import React from 'react';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import VideocamIcon from '@material-ui/icons/Videocam';
import { useAppState } from '../../state';
import UserMenu from './UserMenu/UserMenu';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) => ({
	background: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'center',
		overflowY: 'auto',
		padding: '24px 16px',
		boxSizing: 'border-box',
		background: theme.palette.background.default,
		height: '100%',
		[theme.breakpoints.down('sm')]: {
			padding: '12px 8px',
		},
	},
	container: {
		position: 'relative',
		flex: 1,
		margin: 'auto 0',
		width: '100%',
		maxWidth: 920,
		minWidth: 0,
	},
	card: {
		background: theme.palette.background.paper,
		borderRadius: 16,
		border: `1px solid ${theme.palette.divider}`,
		boxShadow: '0 4px 16px rgba(31, 41, 51, 0.08)',
		padding: '28px 40px 32px',
		minWidth: 0,
		boxSizing: 'border-box',
		[theme.breakpoints.down('sm')]: {
			padding: '20px 16px 24px',
			borderRadius: 12,
		},
	},
	brandRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
		marginBottom: 20,
	},
	brandTile: {
		width: 40,
		height: 40,
		borderRadius: 10,
		flexShrink: 0,
		color: '#fff',
		background: theme.palette.primary.main,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	brandName: {
		color: theme.palette.text.secondary,
		letterSpacing: 0.2,
	},
}));

interface IntroContainerProps {
	children: React.ReactNode;
}

const IntroContainer = (props: IntroContainerProps) => {
	const classes = useStyles();
	const { user } = useAppState();
	const location = useLocation();

	return (
		<div className={classes.background}>
			{user && location.pathname !== '/login' && <UserMenu />}
			<div className={classes.container}>
				<div className={classes.card}>
					<div className={classes.brandRow}>
						<div className={classes.brandTile} aria-hidden="true">
							<VideocamIcon />
						</div>
						<Typography
							variant="subtitle1"
							component="p"
							className={classes.brandName}
						>
							Chekkit Video Chat
						</Typography>
					</div>
					{props.children}
				</div>
			</div>
		</div>
	);
};

export default IntroContainer;
